import Image from '@commons/image/Image'
import Video from '@commons/video/Video'
import { InitiativesCardProps } from '@components/initiatives/initiatives.types'
import { selectPromotion } from '@content/helpers/src/gtmEvents'
import cn from 'classnames'
import ExpandableButton from '@commons/expandable-button/ExpandableButton.tsx'
import { useRef } from 'preact/hooks'
import useImpressionTracker from '@content/helpers/src/hooks/useImpressionTracker'
import ModalTrigger from '@commons/enhanced-modal/ModalTrigger.tsx'

const InitiativesCard = ({
    heading,
    label,
    video,
    cardVariant,
    image,
    logo,
    link,
    promotion_details,
    cardIndex,
    isLarge = false,
    onCardVideoSelected,
    campaign,
    setSelectedPromotionDetails
}: InitiativesCardProps) => {
    const split = cardVariant === 'background-split'

    const containerRef = useRef(null)

    useImpressionTracker(containerRef, campaign)

    const onLinkClick = (label: string, href: string) => {
        selectPromotion({
            ...campaign,
            cta_name: `Link - ${cardIndex + 1} - ${label}`
        })

        if (href) {
            window.location.href = href
        }
    }

    const RenderLink = ({ link, video, promotion_details }) => {
        if (link?.label && !video?.url) {
            return (
                <span className={'initiatives__card__button'}>
                    <ExpandableButton
                        {...link}
                        onClick={() => {
                            onLinkClick(link.label, link.link)
                        }}
                        config={{
                            iconPosition:
                                link?.config?.iconPosition ?? 'leading'
                        }}
                        icon={link?.config?.icon || '24/symbol/chevron-right'}
                    />
                </span>
            )
        }

        if (
            promotion_details?.promo_link?.label &&
            !link?.label &&
            !video.url
        ) {
            return (
                <span className={'initiatives__card__button'}>
                    <ExpandableButton
                        {...link}
                        onClick={() => {
                            onLinkClick(link.label, link.link)
                        }}>
                        <ModalTrigger
                            onClick={() => {
                                setSelectedPromotionDetails(promotion_details)
                            }}
                            {...promotion_details.promo_link}
                        />
                    </ExpandableButton>
                </span>
            )
        }

        return null
    }

    return (
        <>
            <div
                ref={containerRef}
                className={cn('initiatives__card', {
                    'initiatives__card--split': split,
                    'initiatives__card--lg': isLarge
                })}>
                <div className="initiatives__card__media">
                    {!video?.url ? (
                        <Image
                            src={image?.desktop?.src}
                            alt={image?.desktop?.alt}
                            className="initiatives__card__image"
                        />
                    ) : null}
                    <div
                        className="initiatives__card__overlay"
                        style={{
                            backgroundColor: 'rgba(0, 0, 0, 0.4)'
                        }}
                    />

                    {logo && <Image image={logo} />}

                    {video && (
                        <Video
                            url={video.url}
                            urlMobile={video.url_mobile}
                            auto_play={video?.config?.auto_play}
                            button={link}
                            hasModal
                            onVideoClick={e =>
                                onCardVideoSelected(e, cardIndex)
                            }
                        />
                    )}
                </div>

                <div className="initiatives__card__inner">
                    <span>{label}</span>
                    <h3>{heading}</h3>
                    <RenderLink
                        link={link}
                        video={video}
                        promotion_details={promotion_details}
                    />
                </div>
            </div>
        </>
    )
}

export default InitiativesCard
